import NinjaTable from 'components/tables/NinjaTable';
import React, { useMemo, useState } from 'react';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import Widget from 'components/Widget/Widget';
import {
  AdFormatter,
  AdsetFormatter,
  CampaignFormatter,
} from 'components/tables/NinjaTable/formatters/sourceFormatters';
import WidgetsCommonColumns from 'components/widgets/components/WidgetsCommonColumns';

const BestAds = ({ height, index, data, configuration }) => {
  const { dates } = useWidgetDate('best_ads' + index);
  const [widgetLevel, setWidgetLevel] = useState('adset');

  const levelColumns = useMemo(
    () => ({
      adset: {
        key: 'network_Adset.name',
        name: 'Adset',
        renderCell: AdsetFormatter,
      },
      campaign: {
        key: 'network_campaign.name',
        name: 'Campaign',
        renderCell: CampaignFormatter,
      },
      ad: {
        key: 'network_ad.name',
        name: 'Ad',
        renderCell: AdFormatter,
      },
    }),
    []
  );

  const columns = useMemo(
    () => [
      {
        ...levelColumns[widgetLevel],
        resizable: true,
        sortable: true,
        cellClass: 'stretch',
        minWidth: 250,
        frozen: true,
        renderSummaryCell: () => 'Totals',
      },
      ...WidgetsCommonColumns(),
    ],
    [widgetLevel, levelColumns]
  );

  return (
    <Widget
      onLevelChange={(level) => setWidgetLevel(level)}
      tableWidget
      widget_key={'best_ads' + index}
      title={data.title}
      index={index}
      data={data}
      default_filter={data.defaultFilter}
      configuration={configuration}
      adsFilter
      adsetFilter
      campaignFilter
      disableDateFilter
      customize
      showDatePicker
      position={data?.position}
      dashboard_widget_key={data?.key}
    >
      <NinjaTable
        columns={columns}
        dataProvider='dashboardBestAds'
        queryParams={{ ...dates }}
        cardProps={{ disable: true }}
        disableFooter={true}
        maxHeight={height}
        tableProps={{ template: 'widget' }}
      />
    </Widget>
  );
};

export default BestAds;
